import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Pasaré hambre?',
  a: 'No, priorizamos proteínas y grasas saciantes que mantienen tu cerebro tranquilo.'
}, {
  q: '¿Es difícil de seguir?',
  a: 'Son ingredientes que encuentras en cualquier mercado local (pollo, pescado, verduras básicas).'
}, {
  q: '¿Puedo tomar café?',
  a: 'Sí, te enseñamos cómo tomarlo para que no interrumpa el proceso de desinflamación.'
}, {
  q: '¿Tengo que cocinar mucho?',
  a: 'No, las comidas se preparan en menos de 15 minutos con técnicas sencillas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-24 bg-cream" data-id="element-90">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-91">
        <FadeIn data-id="element-92">
          <div className="text-center mb-8 md:mb-16" data-id="element-93">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-94">
              Preguntas Frecuentes
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-95">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-96">
              <div className="bg-white rounded-2xl border border-mint/50 overflow-hidden shadow-sm" data-id="element-97">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-98">
                  <span className="font-bold text-lg text-forest font-sans" data-id="element-99">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-sage transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-100" />
                </button>
                <AnimatePresence data-id="element-101">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-102">
                      <div className="px-6 pb-5 text-gray-600 leading-relaxed" data-id="element-103">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}